import { RootState } from '@store';

export const selectCartData = (state: RootState) => {
  return state.cartData.cartData;
};
